<template>
  <div class="flex-1 flex flex-col w-1/2">
    <div class="h-full">
      <iframe id="htmloutput" :srcdoc="output"></iframe>
    </div>
  </div>
</template>

<script>
import PhpLoading from './PhpLoading.vue';

export default {
  name: 'HtmlOutput',
  components: {
    PhpLoading,
  },
  props: {
    value: String,
  },
  data() {
    return {
      output: `<!DOCTYPE html>
<html class="h-full" lang="en">
    <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">

        <title>Tinkerwell</title>

        <!-- Styles -->
        <link href="https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css" rel="stylesheet">

    </head>
    <body class="h-full">
        <div class="flex justify-center items-center h-full">
            <div class="text-center">
                <div class="text-6xl text-gray-700 font-bold">
                    Tinkerwell
                </div>

                <div class="uppercase font-bold text-sm text-gray-600">
                    <a href="https://tinkerwell.app">Get Tinkerwell App</a>
                </div>
            </div>
        </div>
    </body>
</html>
`,
    };
  },
  watch: {
    output: {
      handler: function(value) {
        let iFrame = document.querySelector('#htmloutput').contentWindow.document;
        iFrame.open('text/html', 'replace');
        iFrame.write(value);
        iFrame.close();
      },
      immediate: true,
    },
  },
  computed: {
    phpLoaded() {
      return this.$store.state.Code.phpLoaded;
    },
  },
  methods: {
    linkClicked(data) {
      this.$root.$emit('php.run.request', 'GET', data.url);
    },
    formSubmitted(data) {
      this.$root.$emit('php.run.request', data.method, 'http://localhost/' + data.url + '?' + data.formData);
    },
    injectJavascript(output) {
        output = '<script src="https://code.jquery.com/jquery-3.4.1.slim.min.js"></' + 'script/>' + output;

        output += `<script>
        $(function(){
          $('a').on('click', function(e) {
            if($(this).attr('href') === undefined) {
              return;
            }
            window.parent.postMessage({
              'event': 'iframe-link-click', 
              'data': {
                url: $(this).attr('href')
              }
            }, '*');
            e.preventDefault();
          });
          $('form').on('submit', function(e) {
            window.parent.postMessage({
              'event': 'iframe-form-submit', 
              'data': {
                url: $(this).attr("action"),
                method: $(this).attr("method"),
                formData: $(this).serialize()
              }
            }, '*');

            e.preventDefault();            
          });
        });</` + `script>`;

        return output;
    }
  },
  mounted() {
    this.$root.$on('iframe-link-click', this.linkClicked);
    this.$root.$on('iframe-form-submit', this.formSubmitted);
    this.$root.$on('iframe-fetch', this.fetch);

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'loadSnippet') {
        this.output = this.injectJavascript(mutation.payload.output);
      }
    });
  },
  created() {
    this.$root.$on('php.loaded', () => {
      this.$store.dispatch('setPHPLoaded', true);
    });

    this.$root.$on('php.print', (lines) => {
      this.output = this.injectJavascript(lines);
    });
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
